import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose, QueryResult, Query } from 'react-apollo';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers';
import * as Queries from '@api/graphql/queries';
import { UserSortField, OrderDirection, adminUser, adminUser_listAdmins_data } from '@api/graphql/types';
import EditForm from '../components/EditForm';
import IpForm from '../components/IpForm';
import PermissionsForm from '../components/PermissionsForm';

type Props = {
    id: string,
} & InjectedIntlProps & RouteComponentProps<{ id: string }>;

interface State {
    editFormData: any;
    permissionFormData: any;
}

class AdminUserEdit extends React.Component<Props, State> {

    private renderInfo = (user: adminUser_listAdmins_data): JSX.Element => {
        return (
            <div className="row">
                <div className="col-sm-3">
                    <strong>
                        {this.props.intl.formatMessage({ id: 'module.adminUser.last_login.title' })}
                    </strong>
                </div>
                <div className="col-sm-9">
                    {user.last_login && user.last_login}
                </div>
            </div>
        );
    }

    private renderForms(result: QueryResult<adminUser>) {
        if (result.loading) return null;
        if (result.error) return `Error!: ${result.error}`;

        if (result.data && result.data.listAdmins) {
            if (result.data.listAdmins.data[0]) {
                const user = result.data.listAdmins.data[0];
                return (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h5>{this.props.intl.formatMessage({ id: 'module.adminUser.edit.title' })}</h5>
                                </div>
                                <div className="ibox-content">
                                    <EditForm user={user} />
                                    <IpForm user={user} />
                                    <PermissionsForm user={user} />
                                    {this.renderInfo(user)}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
        return null;
    }

    public render() {
        const variables = { filters: { id: this.props.id }, sortBy: { field: UserSortField.ID, direction: OrderDirection.ASC }, count: 1 };
        return (
            <Query query={Queries.adminUser} variables={variables}>
                {queryResult => this.renderForms(queryResult)}
            </Query>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { id } = props.match.params;
    return { id };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(AdminUserEdit);



// WEBPACK FOOTER //
// ./src/modules/AdminUser/pages/AdminUserEdit.tsx